<div class="row requestHeader bg-light default-top-boxrounded border-bottom">
    <div class="col-9 builder-navigation">
        <nav ngbNav #nav="ngbNav">
            <ng-container *ngFor="let tabName of workflowSteps; let i = 'index+1';">
                <ng-container ngbNavItem="{{tabName}}" [disabled]="disableTabOrb(tabName)">
                    <a ngbNavLink (click)="tabOrbsClicked(tabName)">
                        <div class="builder-step-block">
                            <h6 [ngClass]="{active : currentTab === tabName}" class="text-truncate" translate>
                                Request.{{tabName}}</h6>
                        </div>
                        <div class="d-block">
                            <!-- TAB NUMBER CIRCLE THINGIE-->
                            <i class="bi bi-{{i}}-circle-fill" [ngClass]="{
                                error :
                                    (
                                        (tabName === 'AddDocuments' && markError_Tab_Documents) || 
                                        (tabName === 'AddPersons'  && markError_Tab_Persons) || 
                                        (tabName === 'AddActions' &&  markError_Tab_Actions) || 
                                        (tabName === 'ReviewAndSend' &&  markError_Tab_SendGroups)
                                    )
                                    
                                    }">
                            </i>
                            <div class="requestBuilderHeaderLine" *ngIf="i !== workflowSteps.length">
                            </div>
                        </div>
                    </a>
                </ng-container>
            </ng-container>
        </nav>
    </div>
    <!-- PREVIOUS - NEXT BUTTONS -->
    <div class="col-3 text-end">
        <button [disabled]="disablePreviousButton()" class="btn btn-sm btn-outline-primary mt-4 me-2"
            (click)="previousButtonClicked();" translate="Button.Previous">

        </button>
        <button [disabled]="disableNextButton()" class="btn btn-sm btn-primary mt-4 me-4" (click)="nextButtonClicked();"
            translate="Button.Next">
        </button>
    </div>
</div>

<!-- MEGA DISPLAY OF VALIDATION MESSAGES APPENDED ONTO THE HEADER-->
<ng-container *ngIf="completeValidationSummary">
    <!-- DOCUMENTS-->
    <div *ngIf="currentTab === 'AddDocuments' && displayError_Tab_Documents"
         class="px-4 pt-4">
        <app-builder-validation-messages [validationSummary]="getSummaryForTab(currentTab)"
            [displayValidations]="displayError_Tab_Documents">
        </app-builder-validation-messages>
    </div>
    <!-- DOCUMENTS-->
    <div *ngIf="currentTab === 'AddPersons' && displayError_Tab_Persons"
         class="px-4 pt-4">
        <app-builder-validation-messages [validationSummary]="getSummaryForTab(currentTab)"
            [displayValidations]="displayError_Tab_Persons"></app-builder-validation-messages>
    </div>
    <!-- DOCUMENTS-->
    <div *ngIf="currentTab === 'AddActions' && displayError_Tab_Actions"
         class="px-4 pt-4">
        <app-builder-validation-messages [validationSummary]="getSummaryForTab(currentTab)"
            [displayValidations]="displayError_Tab_Actions"></app-builder-validation-messages>
    </div>
    <!-- DOCUMENTS-->
    <div *ngIf="currentTab === 'ReviewAndSend' && displayError_Tab_SendGroups" 
         class="px-4 pt-4">
        <app-builder-validation-messages [displayValidations]="displayError_Tab_SendGroups"
            [validationSummary]="getSummaryForTab(currentTab)"></app-builder-validation-messages>
    </div>
</ng-container>